import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import Colors from "../../Color/Colors";
import { Image } from "../../Image/Image/Image";
import { Icon } from "../../Icon/Icon/Icon";
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Link } from "../../Button/Link/Link";
import styles from "./SectionTwo.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionTwo = function SectionTwo(_ref) {
  var _left$link, _left$image, _left$image2, _right$link, _right$image, _right$image2;
  var left = _ref.left,
    right = _ref.right,
    footerText = _ref.footerText;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.sectionTwo,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.columns,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.left,
        children: (left === null || left === void 0 ? void 0 : (_left$link = left.link) === null || _left$link === void 0 ? void 0 : _left$link.url) && /*#__PURE__*/_jsxs(Link, {
          href: left.link.url,
          attributes: left.link.attributes,
          className: styles.inner,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.content,
            children: [(left === null || left === void 0 ? void 0 : left.heading) && /*#__PURE__*/_jsx(HeadingText, {
              richText: true,
              align: "left",
              className: styles.heading,
              typog: left.heading.typog,
              ariaLevel: left.heading.ariaLevel,
              children: left.heading.text
            }), (left === null || left === void 0 ? void 0 : left.bodyText) && /*#__PURE__*/_jsx(Text, {
              richText: true,
              className: styles.text,
              typog: "bodycopyLarge",
              children: left.bodyText
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [(left === null || left === void 0 ? void 0 : left.button) && /*#__PURE__*/_jsxs("div", {
              className: styles.buttonWrapper,
              children: [/*#__PURE__*/_jsx(Button, _objectSpread({
                className: styles.button
              }, left === null || left === void 0 ? void 0 : left.button)), /*#__PURE__*/_jsx(Icon, {
                fill: Colors.colorWW110,
                width: "16px",
                height: "16px",
                type: "primary-link"
              })]
            }), (left === null || left === void 0 ? void 0 : (_left$image = left.image) === null || _left$image === void 0 ? void 0 : _left$image.mobile) && (left === null || left === void 0 ? void 0 : (_left$image2 = left.image) === null || _left$image2 === void 0 ? void 0 : _left$image2.desktop) && /*#__PURE__*/_jsx("div", {
              className: styles.image,
              children: /*#__PURE__*/_jsxs(Breakpoint, {
                breakpoint: "small",
                children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                  className: styles.image
                }, left.image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                  className: styles.image
                }, left.image.desktop))]
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.right,
        children: (right === null || right === void 0 ? void 0 : (_right$link = right.link) === null || _right$link === void 0 ? void 0 : _right$link.url) && /*#__PURE__*/_jsxs(Link, {
          href: right.link.url,
          attributes: right.link.attributes,
          className: styles.inner,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.content,
            children: [(right === null || right === void 0 ? void 0 : right.heading) && /*#__PURE__*/_jsx(HeadingText, {
              richText: true,
              align: "left",
              className: styles.heading,
              typog: right.heading.typog,
              ariaLevel: right.heading.ariaLevel,
              children: right.heading.text
            }), (right === null || right === void 0 ? void 0 : right.bodyText) && /*#__PURE__*/_jsx(Text, {
              richText: true,
              className: styles.text,
              typog: "bodycopyLarge",
              children: right.bodyText
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [(right === null || right === void 0 ? void 0 : right.button) && /*#__PURE__*/_jsxs("div", {
              className: styles.buttonWrapper,
              children: [/*#__PURE__*/_jsx(Button, _objectSpread({
                className: styles.button
              }, right === null || right === void 0 ? void 0 : right.button)), /*#__PURE__*/_jsx(Icon, {
                fill: Colors.colorWW110,
                width: "16px",
                height: "16px",
                type: "primary-link"
              })]
            }), (right === null || right === void 0 ? void 0 : (_right$image = right.image) === null || _right$image === void 0 ? void 0 : _right$image.mobile) && (right === null || right === void 0 ? void 0 : (_right$image2 = right.image) === null || _right$image2 === void 0 ? void 0 : _right$image2.desktop) && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs(Breakpoint, {
                breakpoint: "small",
                children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                  className: styles.image
                }, right.image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                  className: styles.image
                }, right.image.desktop))]
              })
            })]
          })]
        })
      })]
    }), footerText && /*#__PURE__*/_jsx(Text, {
      align: "center",
      richText: true,
      className: styles.footer,
      typog: "bodycopyExtraSmall",
      children: footerText
    })]
  });
};